export const alert = {
    namespaced: true,
    state: {
      defaultMessage: {
        color: 'primary',
        timeout: 7000
      },
      messages:[]
    },
    actions: {
        success ({ dispatch }, message) {
          dispatch('showMessgae', {text: message, color:'success'})
        },
        error ({ dispatch }, message) {
          dispatch('showMessgae', {text: message, color:'error'})
        },
        showMessgae ({dispatch, commit, state }, message) {
          const newMessage = Object.assign({}, state.defaultMessage, message)
          commit('addMessage', newMessage)
          dispatch('hideMessage', state.messages[state.messages.length-1])
        },
        hideMessage ({ commit }, {id, timeout}) {
            setTimeout(function () {
              commit('deleteMessage', id)
            }, timeout)
        },
    },
    mutations: {
        addMessage (state, message) {
          message.id = state.messages.length ? state.messages[state.messages.length-1].id+1 : 0
          state.messages.push(message)
        },
        deleteMessage (state, id) {
            state.messages = state.messages.filter(message => message.id !== id)
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/alert.module.js